import React from 'react';

import { Stack, Text } from '@mantine/core';

import formatDate from '@/utils/formatDate';

import { ReportInfo } from '@/types/patientList';

import styles from './cellsV2.module.scss';
import { ReportName } from './ReportName';

interface CurrentReportCellProps {
  report: ReportInfo | null;
}

const currentStatusText = (report: ReportInfo) => {
  switch (report.signatureStatus) {
    case 'SIGNED':
      return 'Pending Physician Review';
    case 'NOT_SIGNED':
      return 'Draft';
    case 'DISMISSED':
      return 'Dismissed';
    default:
      return 'Pending Physician Review';
  }
};

export const CurrentReportCell: React.FC<CurrentReportCellProps> = ({ report }) => {
  if (!report)
    return (
      <Text className={styles.muted} fz={14}>
        —
      </Text>
    );

  const formatLastUpdated = (createdAt: string) => {
    if (!createdAt) return 'N/A';
    const formatted = formatDate(createdAt, 'MM-DD-YYYY');
    return formatted || createdAt;
  };

  return (
    <Stack gap={2}>
      <ReportName report={report} />
      <Text className={styles.statusChip} fz={12}>
        {currentStatusText(report)}
      </Text>
      <Text className={styles.sub} fz={12}>
        Transmitted {formatLastUpdated(report.transmissionAt)}
      </Text>
    </Stack>
  );
};
